import React from 'react'
import { FormControl } from 'react-bootstrap'
import { get } from 'lodash'
import Group from './group'

const Title = ({
    value = {},
    onChange = () => {}
}) => {
    return (
        <React.Fragment>
            <Group label='Title'>
                <FormControl
                    value={get(value, 'name', '') || ''}
                    onChange={e => onChange({ ...value, name: e.target.value})}
                    placeholder='Enter Resource Title'
                />
            </Group>
        </React.Fragment>
    )
}

export default Title